import { render } from "./megaTable.vue?vue&type=template&id=74289b8e"
import script from "./megaTable.vue?vue&type=script&lang=js"
export * from "./megaTable.vue?vue&type=script&lang=js"

import "./megaTable.vue?vue&type=style&index=0&id=74289b8e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__